import React from "react";

function ArticlesSection() {
  return (
    <div className="text-black pt-10 pb-20 bg-white w-full max-w-[1280px] mx-auto px-4 2xl:px-0">
      {/* Section Header */}
      <div className="flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl md:text-3xl my-2">Articles</h2>
          <div className="border-b-4 border-green-600 w-16 mx-auto" />
        </div>
      </div>

      {/* Content */}
      <div className="flex flex-wrap justify-evenly mt-6">
        <h3 className="text-base md:text-lg">Articles are coming soon.</h3>
      </div>
    </div>
  );
}

export default ArticlesSection;
